import React from "react";
import { connect } from "react-redux";
import FiltroToku from "./list-transactions-toku/components/FiltroToku";
import { listTokuAction } from "_models/redux/list-transactions-toku/action";
import { Grid, Typography } from "@mui/material";
import { PageTokuHook } from "./list-transactions-toku/hooks/PageTokuHook";
import CircularProgress from "@mui/material/CircularProgress";
import { CircularProgressStyle } from "./list-transactions-toku/style/style";
import DataTable from "widgets/datagrid/DataTable";
import CustomDialog from "widgets/component/CustomDialog";
import { detailTransactionTokuAction } from "_models/redux/detail-transactions-toku/action";
import { cleanTransactionsTokuClean } from "_models/redux/list-transactions-toku/clean-action";
import DataTableDetailOrder from "widgets/customDialogComponentDetails/componentDialog";
import { cleanDetailTokuAction } from "_models/redux/detail-transactions-toku/clean-action";

const PageToku = ({
    listTokuAction,
    cleanTransactionsTokuClean,
    listTransactionsToku,
    detailTransactionTokuAction,
    cleanDetailTokuAction,
    detailsTransactionsToku,
}) => {
    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleCleanFilters,
        loading,
        page,
        size,
        pagination,
        mappedRows,
        handleRowClick,
        Columns,
        isDialogOpen,
        dialogMessage,
        handleClose,
        isDialogOpenDetails,
        errorMessage,
        getBackgroundColor,
        getTextColor,
    } = PageTokuHook({
        listTokuAction,
        cleanTransactionsTokuClean,
        listTransactionsToku,
        detailTransactionTokuAction,
        cleanDetailTokuAction,
        detailsTransactionsToku,
    });

    return (
        <>
            <Grid>
                <h4> Transacciones de Toku </h4>
            </Grid>
            <Grid marginBottom={4}>
                <FiltroToku
                    onSubmit={onSubmit}
                    handleSubmit={handleSubmit}
                    errors={errors}
                    register={register}
                    onCleanFilters={handleCleanFilters}
                />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            </Grid>
            <Grid>
                {loading ? (
                    <CircularProgress
                        style={CircularProgressStyle.CircularProgress}
                    />
                ) : (
                    <>
                        {mappedRows?.length > 0 ? (
                            <Grid paddingRight={5} paddingLeft={0}>
                                <DataTable
                                    rows={mappedRows}
                                    columns={Columns}
                                    onRowClick={handleRowClick}
                                    page={page}
                                    pageSize={size}
                                    rowCount={pagination?.total_rows ?? 0}
                                    onPageChange={pagination?.handleChangePage}
                                    handleChangePageSize={
                                        pagination?.handleChangePageSize
                                    }
                                    getBackgroundColor={getBackgroundColor}
                                    mappedRows={mappedRows}
                                    getTextColor={getTextColor}
                                />
                            </Grid>
                        ) : (
                            <Typography variant="h6">
                                No hay registros disponibles
                            </Typography>
                        )}
                    </>
                )}
            </Grid>

            <CustomDialog
                fullWidth
                title="Transacción Toku"
                content={
                    <DataTableDetailOrder
                        response={detailsTransactionsToku?.response}
                    />
                }
                open={isDialogOpenDetails}
                onClose={handleClose}
                maxWidth="md"
                extraButtons={[
                    {
                        label: "Aceptar",
                        variant: "contained",
                        onClick: handleClose,
                        buttonColor: "purple",
                        textColor: "white",
                    },
                ]}
            />

            <CustomDialog
                title="Mensaje"
                content={<p>{dialogMessage}</p>}
                open={isDialogOpen}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                extraButtons={[
                    {
                        label: "Aceptar",
                        variant: "contained",
                        onClick: handleClose,
                        buttonColor: "purple",
                        textColor: "white",
                    },
                ]}
            />
        </>
    );
};

const mapStateToProps = (state) => ({
    listTransactionsToku: state?.listTransactionsToku,
    detailsTransactionsToku: state?.detailsTransactionsToku,
});

const mapDispatchToProps = {
    listTokuAction,
    cleanTransactionsTokuClean,
    detailTransactionTokuAction,
    cleanDetailTokuAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageToku);
